import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, adminCall, formatApiError } from "../../api";

export default function MessagesPanel() {
  const [messages, setMessages] = useState(null);

  const load = () =>
    adminCall(() => api.get("/admin/messages"))
      .then((r) => setMessages(r.data.messages))
      .catch((e) => toast.error(formatApiError(e)));

  useEffect(() => {
    load();
  }, []);

  const markRead = async (m) => {
    await adminCall(() => api.put(`/admin/messages/${m.id}/read`)).catch(() => {});
    load();
  };

  return (
    <div data-testid="admin-messages-panel">
      <h2 className="font-serif text-2xl text-ink">Messages</h2>
      <p className="mt-1 text-sm text-ink/50">Notes left through the contact page.</p>
      <div className="mt-6 space-y-4" data-testid="admin-messages-list">
        {(messages || []).map((m) => (
          <div key={m.id} className={`rounded-2xl border p-6 ${m.read ? "border-sage/10 bg-white/60" : "border-lavender/30 bg-lavender-tint/40"}`} data-testid={`message-${m.id.slice(0, 8)}`}>
            <div className="flex flex-wrap items-center justify-between gap-2">
              <p className="text-sm font-medium text-ink">
                {m.name} <span className="font-normal text-ink/50">· {m.email}</span>
              </p>
              <div className="flex items-center gap-3">
                <span className="text-xs text-ink/40">{new Date(m.created_at).toLocaleString()}</span>
                {!m.read && (
                  <button onClick={() => markRead(m)} data-testid={`mark-read-${m.id.slice(0, 8)}`}
                    className="rounded-full border border-sage/25 px-3 py-1 text-[11px] text-sage transition-colors hover:bg-sage hover:text-cream">
                    Mark read
                  </button>
                )}
              </div>
            </div>
            <p className="mt-3 whitespace-pre-wrap text-sm leading-relaxed text-ink/70">{m.message}</p>
          </div>
        ))}
        {messages && messages.length === 0 && (
          <p className="rounded-2xl border border-sage/12 bg-white/70 px-6 py-10 text-center text-ink/45">No messages yet.</p>
        )}
      </div>
    </div>
  );
}
